define('socket',['lib/socket.io'], function(io) {
	var socket = io.connect('/');

	/**
	 * Maps event names to lists of currently registered handlers (callbacks)
	 */
	var currentEvents = {};

	var lastEmittedEvents = [];

	var emitRegisteredEventsTimeout = null;

	var exports = {
		/**
		 * Makes sure the handler is registered for a specific event, and that the event is
		 * subscribed to.
		 *
		 * @param event the name of the event
		 * @param handler the handler callback
		 * @return bool true, if the handler has been added, false if it is already registered
		 */
		on: function(event, handler) {
			if (isHandlerRegistered(event, handler)) {
				return false;
			}

			socket.on(event, handler);
			registerHandler(event, handler);
			return true;
		},

		/**
		 * Removes the handler from a specific event, and if there are no more handlers fo that
		 * event, unsubscribes from the event.
		 *
		 * @param event the event name
		 * @param handler the handler
		 * @return bool true, if the handler has been removed, false if it was not registered
		 */
		off: function(event, handler) {
			if (!isHandlerRegistered(event, handler)) {
				return false;
			}

			socket.removeListener(event, handler);
			unregisterHandler(event, handler);
			return true;
		},

		register: function() {

		}
	};

	function isHandlerRegistered(event, handler) {
		if (!(event in currentEvents)) {
			return false;
		}
		return currentEvents[event].indexOf(handler) >= 0;
	}

	function registerHandler(event, handler) {
		if (event in currentEvents) {
			var handlers = currentEvents[event];
			if (handlers.indexOf(handler) < 0) {
				handlers.push(handler);
			}
		} else {
			currentEvents[event] = [ handler ];
		}

		emitRegisteredEvents();
	}

	function unregisterHandler(event, handler) {
		if (!(event in currentEvents)) {
			return;
		}

		var handlers = currentEvents[event];
		var index = handlers.indexOf(handler);
		if (index >= 0) {
			handlers.splice(index, 1); // remove
		}
		if (handlers.length == 0) {
			delete currentEvents[event];
		}

		emitRegisteredEvents();
	}

	function emitRegisteredEvents() {
		if (emitRegisteredEventsTimeout) {
			return;
		}

		// Defer the actual emit until the end of the current javascript execution block to avoid
		// unnecessarily many emits
		emitRegisteredEventsTimeout = setTimeout(function() {
			emitRegisteredEventsNow();
			emitRegisteredEventsTimeout = null;
		}, 0);
	}

	function emitRegisteredEventsNow() {
		var newEvents = getRegisteredEvents();
		if (JSON.stringify(newEvents) != JSON.stringify(lastEmittedEvents)) {
			socket.emit('register', newEvents);
		}
	}

	function getRegisteredEvents() {
		return Object.getOwnPropertyNames(currentEvents);
	}

	socket.on('ready', function() {
		socket.emit('register', getRegisteredEvents());
	});
	
	return exports;
});

